import { connect } from "react-redux";
import get from "lodash/get";

import {
  getMonitoringsTaskTrips as onGetMonitoringsTaskTrips,
  getMonitoringsTaskTrip as onGetMonitoringsTaskTrip,
  setSeatchTerm as onSetSeatchTerm,
  completedMonitoringsTaskTrip as onCompletedMonitoringsTaskTrip,
  setMonitoringSettingsState as onSetMonitoringSettingsState,
  addUnitToTaskTrip as onAddUnitToTaskTrip,
  addRoutesToTaskTrip as onAddRoutesToTaskTrip,
} from "../../actions/logisticMonitoringsTaskTripsActions";

import {
  handleRecieveTaskTripInformations as onHandleRecieveTaskTripInformations,
  handleStopRecieveTaskTripInformations as onHandleStopRecieveTaskTripInformations,
} from "../../actions/signalRActions";

const mapStateToProps = (state) => ({
  monitoringTaskTripDataStateSR: state.monitoringTaskTrips.monitoringTaskTripDataStateSR,
  monitoringTaskTripsDataState: state.monitoringTaskTrips.monitoringTaskTripsDataState,
  monitoringTaskTripDataState: state.monitoringTaskTrips.monitoringTaskTripDataState,
  monitoringTaskTripCompletedDataState: state.monitoringTaskTrips.monitoringTaskTripCompletedDataState,
  monitoringAddUnitToTaskTripDataState: state.monitoringTaskTrips.monitoringAddUnitToTaskTripDataState,
  monitoringAddRoutesToTaskTripDataState: state.monitoringTaskTrips.monitoringAddRoutesToTaskTripDataState,
  monitoringTaskTrips: get(state, ["monitoringTaskTrips", "monitoringTaskTrips"], []),
  monitoringTaskTrip: get(state, ["monitoringTaskTrips", "monitoringTaskTrip"], null),
  monitoringSettingsState: get(state, ["monitoringTaskTrips", "monitoringSettingsState"], {
    modificationType: 0,
    unitState: null,
    routeState: null,
  }),
  searchTerm: get(state, ["monitoringTaskTrips", "searchTerm"], null),
  signalRLastUpdate: get(state, ["monitoringTaskTrips", "signalRLastUpdate"], new Date()),
  errors: get(state, ["monitoringTaskTrips", "errors"], []),
});

const mapDispatchToProps = {
  onGetMonitoringsTaskTrips,
  onGetMonitoringsTaskTrip,
  onSetSeatchTerm,
  onCompletedMonitoringsTaskTrip,
  onSetMonitoringSettingsState,
  onAddUnitToTaskTrip,
  onAddRoutesToTaskTrip,
  onHandleRecieveTaskTripInformations,
  onHandleStopRecieveTaskTripInformations,
};

const withMonitoringTaskTrips = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withMonitoringTaskTrips };
